<div id="noteDiv">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Notes</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onCloseModel();modalRef.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h4 class="Offmarket-MainHeading" *ngIf="notesInputsModel.TaskName != null && notesInputsModel.TaskName != '' && notesInputsModel.TaskName != undefined">{{notesInputsModel.AssociatedStatusName}}<span style="color:#6e6e6e !important;"> - {{notesInputsModel.TaskName}}</span>  </h4>
    <div class="form-group">
      <div class="form-group" *ngIf="isEditable">
        <textarea class="form-control textarea-min-height" maxlength="200" [(ngModel)]="notesInputsModel.Description" required type="text" placeholder="Please enter comments"></textarea>
        <p class="redtext" *ngIf="(Validation.IsinValid(notesInputsModel.Description) && isSubmit)">Please enter comments </p>
      </div>
      <div class="text-right" *ngIf="isEditable">
        <button class="btn btn-default btn-lg" id="closeModal" (click)="onCloseModel();modalRef.hide();">Cancel</button>
        <button type="button" (click)="saveNote()" class="btn btn-success btn-lg">Save</button>
      </div>
      <!--<div class="table-responsive">
        <h4 class="Offmarket-MainHeading">Task Notes</h4>
        <table class="table basictable row-border hover">
          <tbody>
            <tr *ngFor="let note of notesList;let i = index">
              <td>
                <ul class="connection-list brokerlist be-exchange-list">
                  <li class="clearfix">

                    <div class="right">
                      <div class="row">
                        <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                          <img src="{{note.Image}}" *ngIf="note.Image!=null&&note.Image!=''">
                          <img [src]="'/../../../assets/img/default-profile-img.png'" *ngIf="note.Image==null||note.Image==''" />
                        </div>
                        <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12" style="margin-top:10px">
                          <h6 class="d-flex">
                            {{note.UserName}}
                          </h6>
                        </div>
                        <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12" style="margin-top:10px">
                          <p>
                            <span class="data">
                              {{Validation.convertDateTimeToUTCStamp(note.EnteredOn)| date:'MM/dd/yyyy hh:mm a'}}
                            </span>
                          </p>
                        </div>
                      </div>
                      <h3 style="margin-top:10px">
                        <span [ngStyle]="{'font-weight': note.IsUnReadNote==true && note.UserId!=user.Id ? 'bold' :'normal'}">{{note.Description}}</span>
                        &nbsp;<a *ngIf="note.ObjectTypeId == 312 && (authService.Admin() || ((authService.Seller || authService.Broker) && note.UserId==user.Id))" class="bluetwo" href="javascript:void(0);" (click)="DeleteNote(note)" tooltip="Notes"><i aria-hidden="true" class="icon-close"></i></a>
                      </h3>
                    </div>

                  </li>
                </ul>
              </td>

            </tr>
          </tbody>
        </table>
      </div>-->

      <div class="form-group">
        <div class="table-wrapper">
          <h4 *ngIf="notesList != null && notesList!= undefined && notesList.length > 0" class="Offmarket-MainHeading">Task Notes</h4>
          <table class="table basictable row-border hover note-table">
            <tbody>
              <tr *ngFor="let note of notesList;let i = index ">
                <td>
                  <div class="modal-data-box">
                    <div class="d-flex">
                      <div class="profile-div d-flex align-content-center">
                        <span class="profile-img margin-right-5">
                          <img style="width:32px; height:32px;" src="{{note.Image}}" *ngIf="note.Image!=null&&note.Image!=''">
                          <img style="width:32px; height:32px;" [src]="'/../../../assets/img/default-profile-img.png'" *ngIf="note.Image==null||note.Image==''" />
                        </span>
                        <h6 class="d-flex margin-bottom-0 margin-t-10">
                          {{note.UserName}}
                        </h6>
                      </div>
                      <div class="data-right ml-auto" style="margin-top:10px">
                        <p>
                          <span class="data date">
                            {{Validation.convertDateTimeToUTCStamp(note.EnteredOn)| date:'MM/dd/yyyy hh:mm a'}}
                          </span>
                        </p>
                      </div>
                    </div>
                        <div class="margin-top-10 margin-bottom-0">
                          <span [ngStyle]="{'font-weight': note.IsUnReadNote==true && note.UserId!=user.Id ? 'bold' :'normal'}" class="notes">{{note.Description}}</span>
                          &nbsp;<a *ngIf="note.ObjectTypeId == 312 && (authService.Admin()|| authService.SuperAdmin() || ((authService.Seller || authService.Broker) && note.UserId==user.Id))" class="bluetwo" href="javascript:void(0);" (click)="DeleteNote(note)" tooltip="Notes"><i aria-hidden="true" class="icon-close"></i></a>
                        </div>
                      </div>
</td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>
